export default __webpack_public_path__ + "static/media/up1.d6aec5ac.jpg";